import client from '@/api/client.js'
import store from "@/store";
export default {
    methods: {
        async createTicket(newticket) {
            var meta = {
                clientApiMethod: 'createTicket',
                input: { newticket },
                successText: 'Successfully sent ticket :)'
            }
            var response = await client().post(store.state.apiRouteRoot + "Ticket/Error/New", newticket, { meta: meta })
            return response.data;
        },
    }
}